import authRules from '../authRules';

const addAssignmentViewAssignmentStatus = (user) => {
  const { assignmentStatus } = user.securityLevels;
  if (assignmentStatus >= authRules.addAssignmentViewAssignmentStatus.assignmentStatus) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentViewAssignmentStatus;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/addAssignmentViewAssignmentStatus.js